<div class = "row">
  <div class = "col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class = "col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content">
      <div class="header-title-admin">{{'' | i18n: 'warranty-list'}}</div>
      <div class = "row" style = "margin-bottom: 15px">
        <div class="filter-container">
          <div class="filter-item-blank">&nbsp;</div>
          <div class="filter-item-date">
            <div class="filter-item-label">{{'' | i18n: 'contract-type'}}:</div>
            <select [(ngModel)]="getFilter().contractTypeId" (change)="refreshList()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              @for (c of contractTypes; track c) {
                <option value="{{c.contractType}}">{{c.contractType}}</option>
              }
            </select>
          </div>
          <div class="filter-item-date" style="padding-left: 0.5%;">
            <div class="filter-item-label">{{'' | i18n: 'contract-start'}}:</div>
            <input id="fromDate" type="date" name="fromDate" [(ngModel)]="getFilter().fromDate" (keydown.enter)="refreshList()">
          </div>
          <div class="filter-item-date" style="padding-left: 0.5%;">
            <div class="filter-item-label">{{'' | i18n: 'contract-end'}}:</div>
            <input id="toDate" type="date" name="toDate" [(ngModel)]="getFilter().toDate" (keydown.enter)="refreshList()">
          </div>
          <div class="filter-item-date" style="padding-left: 0.5%;">
            <div class="filter-item-label">{{'' | i18n: 'brand'}}:</div>
            <select [(ngModel)]="getFilter().brand" (change)="refreshList()">
              <option value="null">{{'' | i18n: 'select'}}</option>
              <option value="bmw">BMW</option>
              <option value="mini">MINI</option>
              <option value="bmwi">BMWi</option>
              <option value="motorrad">Motorrad</option>
            </select>
          </div>
          <div class="filter-item-search" style="padding-left: 0.5%;">
            <div class="filter-item-label">{{'' | i18n: 'dash-keyword'}}:</div>
            <input id="keyword" type="text" name="keyword" [(ngModel)]="getFilter().keyword" placeholder="{{'' | i18n: 'dash-keyword'}}" (keydown.enter)="refreshList()">
          </div>
          <div class="filter-item-search-btn" style="padding-top: 22px; margin-left: 10px; margin-left: -14px;">
            <button id="refresh" (click)="refreshList()" class="button search-btn">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
          <div class="filter-item-search-btn" style="padding-top: 22px">
            <button (click)="clearFilter()" class="button search-btn">
              <i class="fa fa-times" aria-hidden="true"></i>
              <!--      <img alt="" src="assets/images/BMW-clear-144.png" width="20px" style="padding-top: 3px;">-->
            </button>
          </div>

          <div class="pagecount-container" style="padding-top: 22px">
            <button id="removePage" #removePage (click)="changePage(-1)" class="button button-page" [disabled]="this.getFilter().page == 0"><img alt="" src="assets/images/BMW-previous-144.png"  width="20px" height="20px"></button>
            <div class="page-text-container"> {{ getFilter().page + 1 }} </div>
            <button id="addPage" #addPage (click)="changePage(1)" class="button button-page" [disabled]="this.warrantyList.pageCount > this.getFilter().page"><img alt="" src="assets/images/BMW-next-144.png"  width="20px" height="20px"></button>
          </div>
        </div>
      </div>
      <div class="form-row-container">
        <div class="table-header">
          <div class="table-header-item-status">
            <a (click)="orderBy('status')">{{'' | i18n: 'status'}}@if (getFilter().orderBy == 'status') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('vin')">{{'' | i18n: 'chassis'}}@if (getFilter().orderBy == 'vin') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('licence')">{{'' | i18n: 'licence'}}@if (getFilter().orderBy == 'licence') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('brand')">{{'' | i18n: 'brand'}}@if (getFilter().orderBy == 'brand') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('model')">{{'' | i18n: 'model'}}@if (getFilter().orderBy == 'model') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('contractType')">{{'' | i18n: 'warranty-type'}}@if (getFilter().orderBy == 'contractType') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('contractCode')">{{'' | i18n: 'contract-code'}}@if (getFilter().orderBy == 'contractCode') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('warrantyNumber')">{{'' | i18n: 'contract-number'}}@if (getFilter().orderBy == 'warrantyNumber') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('contractStartDate')">{{'' | i18n: 'contract-start'}}@if (getFilter().orderBy == 'contractStartDate') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('contractEndDate')">{{'' | i18n: 'contract-end'}}@if (getFilter().orderBy == 'contractEndDate') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <div class="table-header-item-status">
            <a (click)="orderBy('contractMileage')">{{'' | i18n: 'mileage'}}@if (getFilter().orderBy == 'contractMileage') {
              <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
            }</a>
          </div>
          <!--   <div class="table-header-item-status">
          <a (click)="orderBy('fullName')">{{'' | i18n: 'customer-name'}}<img *ngIf="getFilter().orderBy == 'fullName'" src="{{showDirectionImage()}}" alt="" class="sort-img"/></a>
        </div>-->
        <!--          <div class="table-header-item-status">-->
        <!--            <a>{{'' | i18n: 'owner'}}<img alt="" class="sort-img"/></a>-->
      <!--          </div>-->
      <!--          <div class="table-header-item-status">-->
      <!--            <a>User name<img alt="" class="sort-img"/></a>-->
    <!--          </div>-->
    <!--    <div class="table-header-item-warranty-type">-->
    <!--      <a (click)="orderBy('category')">{{'' | i18n: 'driver-name'}}<img *ngIf="getFilter().orderBy == 'category'" src="{{showDirectionImage()}}" alt="" class="sort-img"/></a>-->
  <!--    </div>-->
  <div class="table-header-item-status">
    <a (click)="orderBy('contractRate')">{{'' | i18n: 'premium'}}@if (getFilter().orderBy == 'contractRate') {
      <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
    }</a>
  </div>
  <div class="table-header-item-status">
    <a>Attachment<img alt="" class="sort-img"/></a>
  </div>
</div>

@for (r of warrantyList.dataList; track r) {
  <div class="table-list">
    <div class="table-list-item-status"><div class = "pending">{{ r.status }}</div></div>
    <div class="table-list-item-status">{{ r.vin }}</div>
    <div class="table-list-item-status">{{ r.licence }}</div>
    <div class="table-list-item-status">{{ r.brand }}</div>
    <div class="table-list-item-status">{{ r.model }}</div>
    <div class="table-list-item-status">{{ r.contractType }}</div>
    <div class="table-list-item-status">{{ r.contractCode }}</div>
    <div class="table-list-item-status">{{ r.warrantyNumber }}</div>
    <div class="table-list-item-status">{{ r.contractStartDate }}</div>
    <div class="table-list-item-status">{{ r.contractEndDate }}</div>
    <div class="table-list-item-status">{{ r.contractMileage }}</div>
    <!--          <div class="table-list-item-status">{{r.}}</div>-->
    <!--          <div class="table-list-item-status">User Name</div>-->
    <!--    <div class="table-list-item-warranty-type">{{ r.driverName }}</div>-->
    <div class="table-list-item-status">{{decimalUtil.enforceDecimals(r.contractRate)}}</div>
    <div class=" table-list-item-status">
      <a routerLink="/warranty/{{r.id}}" class = "table-list-item-status-file"><i class="fa fa-file-o" aria-hidden="true"></i></a>
    </div>
  </div>
}
</div>
</div>
</div>
</div>
